import { Row, Col, Button } from "react-bootstrap";

function ToolActionButtons({
    actions,
    activeValue,
    onAction,
    className = "",
    colClassName = "ActionButtons",
    buttonClassName = "ActionButton",
    activeClassName = "active-btn",
    showActiveDot = true,
    getValue = (action) => action.value ?? action,
    getLabel = (action) => action.name ?? action.label ?? action
}) {
    return (
        <Row className={className}>
            <Col className={colClassName}>
                {actions.map((action) => {
                    const value = getValue(action);
                    const isActive = activeValue === value;

                    return (
                        <Button
                            key={value}
                            className={`${buttonClassName} ${isActive ? activeClassName : ""}`}
                            onClick={() => onAction(action)}
                        >
                            {getLabel(action)}
                            {showActiveDot && isActive && <span className="active-dot" />}
                        </Button>
                    );
                })}
            </Col>
        </Row>
    );
}

export function ToolModeToggle({ options, activeValue, onChange }) {
    return (
        <Row className="ActionButtons">
            <Col>
                <div className="encode-toggle-container">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`encode-toggle-btn ${option.className || ""} ${activeValue === option.value ? "active" : ""}`}
                            onClick={() => onChange(option.value)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            </Col>
        </Row>
    );
}

export default ToolActionButtons;
